import _ from 'lodash';
import React, { Component } from 'react';
// @ts-ignore FIXME - Typescript Strict [7016]
import AsyncCreatableSelect from 'react-select/lib/AsyncCreatable';

import Select from 'corp/components/UI/Select';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';
import {
  IInstructionItemJson,
  IInstructionItemWithMinReviewLevelJson,
} from '@scale/shared/types/instructionitem';

interface ISelectInstructionItemProps {
  id: string;
  instructionItems: (IInstructionItemJson | IInstructionItemWithMinReviewLevelJson | any)[];
  isCreatable: boolean;
  query?: Record<string, string>;
  projectId?: string;
  omitCourseFilter?: boolean;
  placeholder: string;
  onChange(g: IInstructionItemJson | IInstructionItemWithMinReviewLevelJson): void;
  onNewOptionClick(item: ISelectItem): Promise<void>;
}

export interface ISelectItem {
  label?: string;
  value?: string;
  query?: Record<string, string>;
}

export default class SelectInstructionItem extends Component<ISelectInstructionItemProps, {}> {
  static defaultProps = {
    placeholder: 'Select an Instruction Item',
    isCreatable: true,
    query: {},
  };

  handleFilterOption = (item: ISelectItem) => {
    return !this.props.instructionItems
      .map(i => i.name)
      .filter(i => !!i)
      .includes(item.label);
  };

  handleIsValidNewOption = (item: ISelectItem) => {
    return (
      item.label &&
      !this.props.instructionItems
        .map(i => i.name)
        .filter(i => !!i)
        .includes(item.label)
    );
  };

  fetchInstructionItems = async (search: string) => {
    const { query, projectId, omitCourseFilter } = this.props;
    const defaultQuery = projectId && !omitCourseFilter ? { courseProject: projectId } : {};
    try {
      const results = await apiFetch(null, 'corp-api/find/instructionitem', {
        query: Object.assign(defaultQuery, query, _.pickBy({ search })),
      });

      const options = results.instructionitems.map((item: $FIXME) => {
        return {
          label: `${item.name} (${item._id})`,
          _id: item._id,
          name: item.name,
        };
      });
      return { options };
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
      return [];
    }
  };

  render() {
    const { isCreatable } = this.props;
    return (
      <>
        {isCreatable && (
          <AsyncCreatableSelect
            {...this.props}
            filterOption={this.handleFilterOption}
            ignoreCase={false}
            className="instruction-select"
            isValidNewOption={this.handleIsValidNewOption}
            loadOptions={this.fetchInstructionItems}
            defaultOptions={true}
          />
        )}
        {!isCreatable && (
          <Select
            {...this.props}
            filterOption={this.handleFilterOption}
            loadOptions={this.fetchInstructionItems}
          />
        )}
        <style jsx global>{`
          .instruction-select .Select-input input {
            margin-top: 10px;
            width: 200px !important;
          }

          .instruction-select .Select-input input:hover {
            background-color: grey;
          }

          .instruction-select .Select-menu-outer .Select-menu .Select-option {
            margin-top: 10px;
          }

          .instruction-select .Select-menu-outer .Select-menu .Select-option:hover {
            background-color: grey;
            color: white;
          }
        `}</style>
      </>
    );
  }
}
